import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass } from '../../../style';
import { TabStyles } from '@tableau/widgets';
import { truncated } from '../Header/SpaceHeaderStyles';

export namespace CollectionsDialogStyles {
  const cssPrefix: string = 'collections-dialog';
  export const ADD_TO_DIALOG_WIDTH = 400;
  export const COLLECTION_MARGIN = 12;
  export const COLLECTION_HEIGHT = 20;
  export const COLLECTION_ITEM_SCROLL_HEIGHT = COLLECTION_HEIGHT * (3/4);

  export const Spinner = cssClass(cssPrefix, 'spinner', {
    marginTop: '48px',
    marginBottom: '48px',
    textAlign: 'center'
  });

  export const ItemsToAdd = cssClass(cssPrefix, 'items-to-add', {
    marginBottom: CommonStyles.Sizes.MediumSpace,
  });

  export const ActionButtonsFlexContainer = cssClass(cssPrefix, 'action-buttons-flex-container', {
    display: 'flex',
    justifyContent: 'space-between',
  });

  export const CreateCollectionButton = cssClass(cssPrefix, 'create-collection-button', {
    marginTop: CommonStyles.Sizes.LargeSpace,
    $nest: {
      '> *': {
        verticalAlign: 'middle'
      }
    }
  });

  export const CollectionsList = cssClass(cssPrefix, 'collections-list', {
    maxHeight: '200px',
    overflowY: 'auto',
    border: `1px solid ${TabStyles!.Colors!.L6}`
  });

  export const CreateCancelButtons = cssClass(cssPrefix, 'create-cancel-buttons', {
    marginTop: CommonStyles.Sizes.LargeSpace,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  });

  export const NewBadge = cssClass(cssPrefix, 'new-badge', {
    background: CommonStyles.Colors.BadgeBlue,
    borderRadius: 2,
    color: CommonStyles.Colors.White,
    letterSpacing: '0.2px',
    textAlign: 'center',
    fontWeight: 'bold',
    marginLeft: 8
  });

  export const CollectionListItemContainer = cssClass(cssPrefix, 'collection-list-item-container', {
    display: 'flex',
    alignItems: 'center',
  });

  const CheckmarkWidth = 12;
  const CheckmarkMargin = 4;
  export const CollectionListItemCheckmark = cssClass(cssPrefix, 'collection-list-item-checkmark', {
    width: CheckmarkWidth,
    marginRight: CheckmarkMargin,
    alignSelf: 'flex-start',
    flexShrink: 0,
  });

  export const CollectionListItemText = cssClass(cssPrefix, 'collection-list-item-text', {
    ...truncated,
    $nest: {
      '&.unchecked': { paddingLeft: CheckmarkWidth + CheckmarkMargin }
    }
  });
}
